export default "__VITE_ASSET__BwObamV___"